import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createAnimatedComponent;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _WorkletEventHandler = _interopRequireDefault(require("../reanimated2/WorkletEventHandler"));
var _setAndForwardRef = _interopRequireDefault(require("./setAndForwardRef"));
require("../reanimated2/layoutReanimation/animationsManager");
var _invariant = _interopRequireDefault(require("invariant"));
var _ConfigHelper = require("../ConfigHelper");
var _RNRenderer = require("../reanimated2/platform-specific/RNRenderer");
var _core = require("../reanimated2/core");
var _PlatformChecker = require("../reanimated2/PlatformChecker");
var _animation = require("../reanimated2/animation");
var _layoutReanimation = require("../reanimated2/layoutReanimation");
var _ViewDescriptorsSet = require("../reanimated2/ViewDescriptorsSet");
var _fabricUtils = require("../reanimated2/fabricUtils");
var _UpdateProps = _interopRequireDefault(require("../reanimated2/UpdateProps"));
var _NativeReanimated = _interopRequireDefault(require("../reanimated2/NativeReanimated"));
var _utils = require("../reanimated2/utils");
var _PropsRegistry = require("../reanimated2/PropsRegistry");
var _JSPropUpdater = require("./JSPropUpdater");
var _util = require("../reanimated2/animation/util");
var _animationBuilder = require("../animationBuilder");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
var _jsxFileName = "/vercel/path0/example/node_modules/react-native-reanimated/src/createAnimatedComponent/createAnimatedComponent.tsx";
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var IS_WEB = (0, _PlatformChecker.isWeb)();
function dummyListener() {}
function onlyAnimatedStyles(styles) {
    return styles.filter(function(style) {
        return style == null ? void 0 : style.viewDescriptors;
    });
}
function isSameAnimatedStyle(style1, style2) {
    return (style1 == null ? void 0 : style1.viewsRef) === (style2 == null ? void 0 : style2.viewsRef);
}
var isSameAnimatedProps = isSameAnimatedStyle;
function isInlineStyleTransform(transform) {
    if (!transform) {
        return false;
    }
    return transform.some(function(t) {
        return hasInlineStyles(t);
    });
}
function hasInlineStyles(style) {
    if (!style) {
        return false;
    }
    return Object.keys(style).some(function(key) {
        var styleValue = style[key];
        return (0, _utils.isSharedValue)(styleValue) || key === "transform" && isInlineStyleTransform(styleValue);
    });
}
function extractSharedValuesMapFromProps(props) {
    var inlineProps = {};
    for(var key in props){
        var value = props[key];
        if (key === "style") {
            var _props$style;
            var styles = (0, _utils2.flattenArray)((_props$style = props.style) != null ? _props$style : []);
            styles.forEach(function(style) {
                if (!style) {
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(style)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ref = _step.value;
                        var _ref2 = (0, _slicedToArray2.default)(_ref, 2);
                        var _key = _ref2[0];
                        var styleValue = _ref2[1];
                        if ((0, _utils.isSharedValue)(styleValue)) {
                            inlineProps[_key] = styleValue;
                        } else if (_key === "transform" && isInlineStyleTransform(styleValue)) {
                            inlineProps[_key] = styleValue;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        } else if ((0, _utils.isSharedValue)(value)) {
            inlineProps[key] = value;
        }
    }
    return inlineProps;
}
function inlinePropsHasChanged(styles1, styles2) {
    if (Object.keys(styles1).length !== Object.keys(styles2).length) {
        return true;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(styles1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (styles1[key] !== styles2[key]) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
var _worklet_7960676920272_init_data = {
    code: "function getInlinePropsUpdate(inlineProps){const getInlinePropsUpdate=this._recur;const{isSharedValue}=this.__closure;const update={};for(const[key,styleValue]of Object.entries(inlineProps)){if(key==='transform'){update[key]=styleValue.map(function(transform){return getInlinePropsUpdate(transform);});}else if(isSharedValue(styleValue)){update[key]=styleValue.value;}else{update[key]=styleValue;}}return update;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/createAnimatedComponent/createAnimatedComponent.tsx",
    sourceMap: '{"version":3,"names":["getInlinePropsUpdate","inlineProps","_recur","isSharedValue","__closure","update","key","styleValue","Object","entries","map","transform","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/createAnimatedComponent/createAnimatedComponent.tsx"],"mappings":"AA6IA,SAAAA,oBAASA,CAAqBC,WAAA,CAAgC,OAAAD,oBAAA,MAAAE,MAAA,OAAAC,aAAA,OAAAC,SAAA,CAE5D,KAAM,CAAAC,MAA2B,CAAG,CAAC,CAAC,CACtC,IAAK,KAAM,CAACC,GAAG,CAAEC,UAAU,CAAC,EAAI,CAAAC,MAAM,CAACC,OAAO,CAACR,WAAW,CAAC,CAAE,CAC3D,GAAIK,GAAG,GAAK,WAAW,CAAE,CACvBD,MAAM,CAACC,GAAG,CAAC,CAAGC,UAAU,CAACG,GAAG,CAAC,SAACC,SAA8B,CAAK,CAC/D,MAAO,CAAAX,oBAAoB,CAACW,SAAS,CAAC,CACxC,CAAC,CAAC,CACJ,CAAC,IAAM,IAAIR,aAAa,CAACI,UAAU,CAAC,CAAE,CACpCF,MAAM,CAACC,GAAG,CAAC,CAAGC,UAAU,CAACK,KAAK,CAChC,CAAC,IAAM,CACLP,MAAM,CAACC,GAAG,CAAC,CAAGC,UAAU,CAC1B,CACF,CACA,MAAO,CAAAF,MAAM,CACf"}',
    version: "3.5.4"
};
var getInlinePropsUpdate = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var getInlinePropsUpdate = function getInlinePropsUpdate(inlineProps) {
        var update = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(inlineProps)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _ref3 = _step.value;
                var _ref4 = (0, _slicedToArray2.default)(_ref3, 2);
                var key = _ref4[0];
                var styleValue = _ref4[1];
                if (key === "transform") {
                    update[key] = styleValue.map(function(transform) {
                        return getInlinePropsUpdate(transform);
                    });
                } else if ((0, _utils.isSharedValue)(styleValue)) {
                    update[key] = styleValue.value;
                } else {
                    update[key] = styleValue;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return update;
    };
    getInlinePropsUpdate.__closure = {
        isSharedValue: _utils.isSharedValue
    };
    getInlinePropsUpdate.__initData = _worklet_7960676920272_init_data;
    getInlinePropsUpdate.__workletHash = 7960676920272;
    getInlinePropsUpdate.__stackDetails = _e;
    return getInlinePropsUpdate;
}();
var _worklet_6705587923381_init_data = {
    code: "function anonymous(){const{getInlinePropsUpdate,newInlineProps,updateProps,sharableViewDescriptors,maybeViewRef}=this.__closure;const update=getInlinePropsUpdate(newInlineProps);updateProps(sharableViewDescriptors,update,maybeViewRef);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/createAnimatedComponent/createAnimatedComponent.tsx",
    sourceMap: '{"version":3,"names":["anonymous","getInlinePropsUpdate","newInlineProps","updateProps","sharableViewDescriptors","maybeViewRef","__closure","update"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/createAnimatedComponent/createAnimatedComponent.tsx"],"mappings":"AAgfgC,SAAAA,SAAMA,CAAA,QAAAC,oBAAA,CAAAC,cAAA,CAAAC,WAAA,CAAAC,uBAAA,CAAAC,YAAA,OAAAC,SAAA,CAE5B,KAAM,CAAAC,MAAM,CAAGN,oBAAoB,CAACC,cAAc,CAAC,CACnDC,WAAW,CAACC,uBAAuB,CAAEG,MAAM,CAAEF,YAAY,CAAC,CAC5D"}',
    version: "3.5.4"
};
function createAnimatedComponent(Component, options) {
    var _this4 = this;
    (0, _invariant.default)(typeof Component !== "function" || Component.prototype && Component.prototype.isReactComponent, "Looks like you're passing a function component `".concat(Component.name, "` to `createAnimatedComponent` function which supports only class components. Please wrap your function component with `React.forwardRef()` or use a class component instead."));
    var AnimatedComponent = function(_React$Component) {
        (0, _inherits2.default)(AnimatedComponent, _React$Component);
        var _super = _createSuper(AnimatedComponent);
        function AnimatedComponent(props) {
            var _this;
            (0, _classCallCheck2.default)(this, AnimatedComponent);
            _this = _super.call(this, props);
            _this._styles = null;
            _this._animatedProps = void 0;
            _this._viewTag = -1;
            _this._isFirstRender = true;
            _this.animatedStyle = {
                value: {}
            };
            _this.initialStyle = {};
            _this._component = null;
            _this._inlinePropsViewDescriptors = null;
            _this._inlinePropsMapperId = null;
            _this._inlineProps = {};
            _this._sharedElementTransition = null;
            _this._JSPropUpdater = new _JSPropUpdater.JSPropUpdater();
            _this._setComponentRef = (0, _setAndForwardRef.default)({
                getForwardedRef: function getForwardedRef() {
                    return _this.props.forwardedRef;
                },
                setLocalRef: function setLocalRef(ref) {
                    var tag = IS_WEB ? ref : (0, _reactNative.findNodeHandle)(ref);
                    var _this$props = _this.props, layout = _this$props.layout, entering = _this$props.entering, exiting = _this$props.exiting, sharedTransitionTag = _this$props.sharedTransitionTag;
                    if ((layout || entering || exiting || sharedTransitionTag) && tag != null) {
                        if (!(0, _PlatformChecker.shouldBeUseWeb)()) {
                            (0, _core.enableLayoutAnimations)(true, false);
                        }
                        if (layout) {
                            (0, _core.configureLayoutAnimations)(tag, _layoutReanimation.LayoutAnimationType.LAYOUT, (0, _animationBuilder.maybeBuild)(layout, undefined, AnimatedComponent.displayName));
                        }
                        if (entering) {
                            var _this$props2;
                            (0, _core.configureLayoutAnimations)(tag, _layoutReanimation.LayoutAnimationType.ENTERING, (0, _animationBuilder.maybeBuild)(entering, (_this$props2 = _this.props) == null ? void 0 : _this$props2.style, AnimatedComponent.displayName));
                        }
                        if (exiting) {
                            var reduceMotionInExiting = "getReduceMotion" in exiting && typeof exiting.getReduceMotion === "function" ? (0, _util.getReduceMotionFromConfig)(exiting.getReduceMotion()) : (0, _util.getReduceMotionFromConfig)();
                            if (!reduceMotionInExiting) {
                                var _this$props3;
                                (0, _core.configureLayoutAnimations)(tag, _layoutReanimation.LayoutAnimationType.EXITING, (0, _animationBuilder.maybeBuild)(exiting, (_this$props3 = _this.props) == null ? void 0 : _this$props3.style, AnimatedComponent.displayName));
                            }
                        }
                        if (sharedTransitionTag && !IS_WEB) {
                            var _this$props$sharedTra;
                            var sharedElementTransition = (_this$props$sharedTra = _this.props.sharedTransitionStyle) != null ? _this$props$sharedTra : new _layoutReanimation.SharedTransition();
                            var reduceMotionInTransition = (0, _util.getReduceMotionFromConfig)(sharedElementTransition.getReduceMotion());
                            if (!reduceMotionInTransition) {
                                sharedElementTransition.registerTransition(tag, sharedTransitionTag);
                                _this._sharedElementTransition = sharedElementTransition;
                            }
                        }
                    }
                    if (ref !== _this._component) {
                        _this._component = ref;
                    }
                }
            });
            if ((0, _PlatformChecker.isJest)()) {
                _this.animatedStyle = {
                    value: {}
                };
            }
            return _this;
        }
        (0, _createClass2.default)(AnimatedComponent, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this$_sharedElementT;
                    this._detachNativeEvents();
                    this._JSPropUpdater.removeOnJSPropsChangeListener(this);
                    this._detachStyles();
                    this._detachInlineProps();
                    (_this$_sharedElementT = this._sharedElementTransition) == null ? void 0 : _this$_sharedElementT.unregisterTransition(this._viewTag);
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this._attachNativeEvents();
                    this._JSPropUpdater.addOnJSPropsChangeListener(this);
                    this._attachAnimatedStyles();
                    this._attachInlineProps();
                }
            },
            {
                key: "_getEventViewRef",
                value: function _getEventViewRef() {
                    var _this$_component, _getScrollableNode, _ref5;
                    return (_this$_component = this._component) != null && _this$_component.getScrollableNode ? (_getScrollableNode = (_ref5 = this._component).getScrollableNode) == null ? void 0 : _getScrollableNode.call(_ref5) : this._component;
                }
            },
            {
                key: "_attachNativeEvents",
                value: function _attachNativeEvents() {
                    var node = this._getEventViewRef();
                    var viewTag = null;
                    for(var key in this.props){
                        var prop = this.props[key];
                        if ((0, _utils2.has)("current", prop) && _instanceof(prop.current, _WorkletEventHandler.default)) {
                            if (viewTag === null) {
                                viewTag = (0, _reactNative.findNodeHandle)(options != null && options.setNativeProps ? this : node);
                            }
                            prop.current.registerForEvents(viewTag, key);
                        }
                    }
                }
            },
            {
                key: "_detachNativeEvents",
                value: function _detachNativeEvents() {
                    for(var key in this.props){
                        var prop = this.props[key];
                        if ((0, _utils2.has)("current", prop) && _instanceof(prop.current, _WorkletEventHandler.default)) {
                            prop.current.unregisterFromEvents();
                        }
                    }
                }
            },
            {
                key: "_detachStyles",
                value: function _detachStyles() {
                    if (IS_WEB && this._styles !== null) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._styles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var style = _step.value;
                                if (style != null && style.viewsRef) {
                                    style.viewsRef.remove(this);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    } else if (this._viewTag !== -1 && this._styles !== null) {
                        var _this$props$animatedP;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = this._styles[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _style = _step1.value;
                                _style.viewDescriptors.remove(this._viewTag);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        if ((_this$props$animatedP = this.props.animatedProps) != null && _this$props$animatedP.viewDescriptors) {
                            this.props.animatedProps.viewDescriptors.remove(this._viewTag);
                        }
                        if (global._IS_FABRIC) {
                            (0, _PropsRegistry.removeFromPropsRegistry)(this._viewTag);
                        }
                    }
                }
            },
            {
                key: "_reattachNativeEvents",
                value: function _reattachNativeEvents(prevProps) {
                    for(var key in prevProps){
                        var prop = this.props[key];
                        if ((0, _utils2.has)("current", prop) && _instanceof(prop.current, _WorkletEventHandler.default) && prop.current.reattachNeeded) {
                            prop.current.unregisterFromEvents();
                        }
                    }
                    var viewTag = null;
                    for(var _key2 in this.props){
                        var _prop = this.props[_key2];
                        if ((0, _utils2.has)("current", _prop) && _instanceof(_prop.current, _WorkletEventHandler.default) && _prop.current.reattachNeeded) {
                            if (viewTag === null) {
                                var node = this._getEventViewRef();
                                viewTag = (0, _reactNative.findNodeHandle)(options != null && options.setNativeProps ? this : node);
                            }
                            _prop.current.registerForEvents(viewTag, _key2);
                            _prop.current.reattachNeeded = false;
                        }
                    }
                }
            },
            {
                key: "_updateFromNative",
                value: function _updateFromNative(props) {
                    if (options != null && options.setNativeProps) {
                        options.setNativeProps(this._component, props);
                    } else {
                        var _this$_component2;
                        (_this$_component2 = this._component) == null ? void 0 : _this$_component2.setNativeProps == null ? void 0 : _this$_component2.setNativeProps(props);
                    }
                }
            },
            {
                key: "_getViewInfo",
                value: function _getViewInfo() {
                    var _this$_component3, _getAnimatableRef, _ref6;
                    var viewTag;
                    var viewName;
                    var shadowNodeWrapper = null;
                    var viewConfig;
                    var component = (_this$_component3 = this._component) != null && _this$_component3.getAnimatableRef ? (_getAnimatableRef = (_ref6 = this._component).getAnimatableRef) == null ? void 0 : _getAnimatableRef.call(_ref6) : this;
                    if (IS_WEB) {
                        viewTag = this._component;
                        viewName = null;
                        shadowNodeWrapper = null;
                        viewConfig = null;
                    } else {
                        var _hostInstance$viewCon;
                        var hostInstance = _RNRenderer.RNRenderer.findHostInstance_DEPRECATED(component);
                        if (!hostInstance) {
                            throw new Error("[Reanimated] Cannot find host instance for this component. Maybe it renders nothing?");
                        }
                        viewTag = hostInstance == null ? void 0 : hostInstance._nativeTag;
                        viewName = hostInstance == null ? void 0 : (_hostInstance$viewCon = hostInstance.viewConfig) == null ? void 0 : _hostInstance$viewCon.uiViewClassName;
                        viewConfig = hostInstance == null ? void 0 : hostInstance.viewConfig;
                        if (global._IS_FABRIC) {
                            shadowNodeWrapper = (0, _fabricUtils.getShadowNodeWrapperFromRef)(this);
                        }
                    }
                    return {
                        viewTag: viewTag,
                        viewName: viewName,
                        shadowNodeWrapper: shadowNodeWrapper,
                        viewConfig: viewConfig
                    };
                }
            },
            {
                key: "_attachAnimatedStyles",
                value: function _attachAnimatedStyles() {
                    var _this$props$animatedP2, _this2 = this, _this$props$animatedP3;
                    var styles = this.props.style ? onlyAnimatedStyles((0, _utils2.flattenArray)(this.props.style)) : [];
                    var prevStyles = this._styles;
                    this._styles = styles;
                    var prevAnimatedProps = this._animatedProps;
                    this._animatedProps = this.props.animatedProps;
                    var _this$_getViewInfo = this._getViewInfo(), viewTag = _this$_getViewInfo.viewTag, viewName = _this$_getViewInfo.viewName, shadowNodeWrapper = _this$_getViewInfo.shadowNodeWrapper, viewConfig = _this$_getViewInfo.viewConfig;
                    var hasReanimated2Props = ((_this$props$animatedP2 = this.props.animatedProps) == null ? void 0 : _this$props$animatedP2.viewDescriptors) || styles.length;
                    if (hasReanimated2Props && viewConfig) {
                        (0, _ConfigHelper.adaptViewConfig)(viewConfig);
                    }
                    this._viewTag = viewTag;
                    if (prevStyles) {
                        var hasOneSameStyle = styles.length === 1 && prevStyles.length === 1 && isSameAnimatedStyle(styles[0], prevStyles[0]);
                        if (!hasOneSameStyle) {
                            var _loop = function _loop(prevStyle) {
                                var isPresent = styles.some(function(style) {
                                    return isSameAnimatedStyle(style, prevStyle);
                                });
                                if (!isPresent) {
                                    prevStyle.viewDescriptors.remove(viewTag);
                                }
                            };
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = prevStyles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var prevStyle = _step.value;
                                    _loop(prevStyle);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    }
                    styles.forEach(function(style) {
                        style.viewDescriptors.add({
                            tag: viewTag,
                            name: viewName,
                            shadowNodeWrapper: shadowNodeWrapper
                        });
                        if ((0, _PlatformChecker.isJest)()) {
                            _this2.animatedStyle.value = Object.assign({}, _this2.animatedStyle.value, style.initial.value);
                            style.animatedStyle.current = _this2.animatedStyle;
                        }
                    });
                    if (prevAnimatedProps && !isSameAnimatedProps(prevAnimatedProps, this.props.animatedProps)) {
                        prevAnimatedProps.viewDescriptors.remove(viewTag);
                    }
                    if ((_this$props$animatedP3 = this.props.animatedProps) != null && _this$props$animatedP3.viewDescriptors) {
                        this.props.animatedProps.viewDescriptors.add({
                            tag: viewTag,
                            name: viewName,
                            shadowNodeWrapper: shadowNodeWrapper
                        });
                    }
                }
            },
            {
                key: "_attachInlineProps",
                value: function _attachInlineProps() {
                    var newInlineProps = extractSharedValuesMapFromProps(this.props);
                    var hasChanged = inlinePropsHasChanged(newInlineProps, this._inlineProps);
                    if (hasChanged) {
                        if (!this._inlinePropsViewDescriptors) {
                            this._inlinePropsViewDescriptors = (0, _ViewDescriptorsSet.makeViewDescriptorsSet)();
                            var _this$_getViewInfo2 = this._getViewInfo(), viewTag = _this$_getViewInfo2.viewTag, viewName = _this$_getViewInfo2.viewName, shadowNodeWrapper = _this$_getViewInfo2.shadowNodeWrapper, viewConfig = _this$_getViewInfo2.viewConfig;
                            if (Object.keys(newInlineProps).length && viewConfig) {
                                (0, _ConfigHelper.adaptViewConfig)(viewConfig);
                            }
                            this._inlinePropsViewDescriptors.add({
                                tag: viewTag,
                                name: viewName,
                                shadowNodeWrapper: shadowNodeWrapper
                            });
                        }
                        var sharableViewDescriptors = this._inlinePropsViewDescriptors.sharableViewDescriptors;
                        var maybeViewRef = _NativeReanimated.default.native ? undefined : {
                            items: new Set([
                                this
                            ])
                        };
                        var updaterFunction = function() {
                            var _e = [
                                new global.Error(),
                                -6,
                                -27
                            ];
                            var anonymous = function anonymous() {
                                var update = getInlinePropsUpdate(newInlineProps);
                                (0, _UpdateProps.default)(sharableViewDescriptors, update, maybeViewRef);
                            };
                            anonymous.__closure = {
                                getInlinePropsUpdate: getInlinePropsUpdate,
                                newInlineProps: newInlineProps,
                                updateProps: _UpdateProps.default,
                                sharableViewDescriptors: sharableViewDescriptors,
                                maybeViewRef: maybeViewRef
                            };
                            anonymous.__initData = _worklet_6705587923381_init_data;
                            anonymous.__workletHash = 6705587923381;
                            anonymous.__stackDetails = _e;
                            return anonymous;
                        }();
                        this._inlineProps = newInlineProps;
                        if (this._inlinePropsMapperId) {
                            (0, _core.stopMapper)(this._inlinePropsMapperId);
                        }
                        this._inlinePropsMapperId = null;
                        if (Object.keys(newInlineProps).length) {
                            this._inlinePropsMapperId = (0, _core.startMapper)(updaterFunction, Object.values(newInlineProps));
                        }
                    }
                }
            },
            {
                key: "_detachInlineProps",
                value: function _detachInlineProps() {
                    if (this._inlinePropsMapperId) {
                        (0, _core.stopMapper)(this._inlinePropsMapperId);
                    }
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    this._reattachNativeEvents(prevProps);
                    this._attachAnimatedStyles();
                    this._attachInlineProps();
                }
            },
            {
                key: "_filterNonAnimatedProps",
                value: function _filterNonAnimatedProps(inputProps) {
                    var _this3 = this;
                    var props = {};
                    var _loop2 = function _loop2() {
                        var value = inputProps[key];
                        if (key === "style") {
                            var styleProp = inputProps.style;
                            var styles = (0, _utils2.flattenArray)(styleProp != null ? styleProp : []);
                            var processedStyle = styles.map(function(style) {
                                if (style && style.viewDescriptors) {
                                    style.viewsRef.add(_this3);
                                    if (_this3._isFirstRender) {
                                        _this3.initialStyle = Object.assign({}, style.initial.value, _this3.initialStyle, (0, _animation.initialUpdaterRun)(style.initial.updater));
                                    }
                                    return _this3.initialStyle;
                                } else if (hasInlineStyles(style)) {
                                    if (_this3._isFirstRender) {
                                        return getInlinePropsUpdate(style);
                                    }
                                    var newStyle = {};
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = Object.entries(style)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _ref7 = _step.value;
                                            var _ref8 = (0, _slicedToArray2.default)(_ref7, 2);
                                            var _key3 = _ref8[0];
                                            var styleValue = _ref8[1];
                                            if (!(0, _utils.isSharedValue)(styleValue) && !(_key3 === "transform" && isInlineStyleTransform(styleValue))) {
                                                newStyle[_key3] = styleValue;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return newStyle;
                                } else {
                                    return style;
                                }
                            });
                            props[key] = _reactNative.StyleSheet.flatten(processedStyle);
                        } else if (key === "animatedProps") {
                            var animatedProp = inputProps.animatedProps;
                            if (animatedProp.initial !== undefined) {
                                Object.keys(animatedProp.initial.value).forEach(function(key) {
                                    var _animatedProp$initial, _animatedProp$viewsRe;
                                    props[key] = (_animatedProp$initial = animatedProp.initial) == null ? void 0 : _animatedProp$initial.value[key];
                                    (_animatedProp$viewsRe = animatedProp.viewsRef) == null ? void 0 : _animatedProp$viewsRe.add(_this3);
                                });
                            }
                        } else if ((0, _utils2.has)("current", value) && _instanceof(value.current, _WorkletEventHandler.default)) {
                            if (value.current.eventNames.length > 0) {
                                value.current.eventNames.forEach(function(eventName) {
                                    props[eventName] = (0, _utils2.has)("listeners", value.current) ? value.current.listeners[eventName] : dummyListener;
                                });
                            } else {
                                props[key] = dummyListener;
                            }
                        } else if ((0, _utils.isSharedValue)(value)) {
                            if (_this3._isFirstRender) {
                                props[key] = value.value;
                            }
                        } else if (key !== "onGestureHandlerStateChange" || !(0, _PlatformChecker.isChromeDebugger)()) {
                            props[key] = value;
                        }
                    };
                    for(var key in inputProps){
                        _loop2();
                    }
                    return props;
                }
            },
            {
                key: "render",
                value: function render() {
                    var props = this._filterNonAnimatedProps(this.props);
                    if ((0, _PlatformChecker.isJest)()) {
                        props.animatedStyle = this.animatedStyle;
                    }
                    if (this._isFirstRender) {
                        this._isFirstRender = false;
                    }
                    var platformProps = _reactNative.Platform.select({
                        web: {},
                        default: {
                            collapsable: false
                        }
                    });
                    return (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, {
                        ref: this._setComponentRef
                    }, platformProps));
                }
            }
        ]);
        return AnimatedComponent;
    }(_react.default.Component);
    AnimatedComponent.displayName = void 0;
    AnimatedComponent.displayName = "AnimatedComponent(".concat(Component.displayName || Component.name || "Component", ")");
    return _react.default.forwardRef(function(props, ref) {
        return (0, _jsxRuntime.jsx)(AnimatedComponent, Object.assign({}, props, ref === null ? null : {
            forwardedRef: ref
        }));
    });
}
